// import React, { useState, useEffect } from "react";
// import { Card, CardContent, Grid, Typography } from "@mui/material";

// const TotalProfit = (props) => {
//   const [labscard, setLabscard] = useState([]);

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_API_URL}/api/labscard/`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + localStorage.getItem("token"),
//       },
//     })
//       .then((resp) => resp.json())
//       .then((data) => {
//         setLabscard(data);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, []);

//   return (
//     <Card {...props}>
//       <CardContent>
//         <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
//           <Grid item>
//             <Typography color="textSecondary" gutterBottom variant="h6">
//               ACTIVE LABS
//             </Typography>
//             <Typography color="textPrimary" variant="h3">
//               {labscard.manualactive}
//             </Typography>
//           </Grid>
//         </Grid>
//       </CardContent>
//     </Card>
//   );
// };

// export default TotalProfit;


import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";

const ManualActive = ({ value }) => (
  <Card>
    <CardContent>
      <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
        <Grid item>
          <Typography color="textSecondary" gutterBottom variant="h6">
          ACTIVE LABS
          </Typography>
          <Typography color="textPrimary" variant="h3">
            {value || 0} {/* Handle undefined initial state */}
          </Typography>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default ManualActive;